/** @jsx jsx */
import { type SerializedStyles, css, jsx } from '@emotion/react';

import config from 'js/app/config';

import type { SectionName } from '@coursera/event-pulse-types';
import { Link } from '@coursera/event-pulse/react';

import { useEventingProductData } from 'bundles/unified-description-page-common/contexts/EventingContext';

const styles = {
  skillsLink: css`
    display: inline-flex;
    align-items: center;
    border: 1px solid;
    border-radius: 4px;
    padding: 0 var(--cds-spacing-100);
    background-color: var(--cds-color-neutral-disabled);
    border-color: var(--cds-color-neutral-disabled);
    box-shadow: none;
    color: var(--cds-color-neutral-primary);

    &:visited:not(.cds-link-focusVisible),
    &:visited,
    &:hover {
      color: var(--cds-color-neutral-primary);
    }
  `,
};

type Props = {
  skill: string;
  cssOverrides?: SerializedStyles;
  sectionName?: SectionName;
};

const SkillsTag = ({ skill, cssOverrides, sectionName }: Props) => {
  const encodedSkill = encodeURIComponent(skill.toLowerCase());
  const href = `${config.url.base}courses?query=${encodedSkill}`;
  const eventingProductData = useEventingProductData();

  return (
    <Link
      variant="quiet"
      typographyVariant="bodySecondary"
      css={[styles.skillsLink, cssOverrides]}
      href={href}
      noViewTracking
      trackingData={{
        button: { name: 'description_page_skill' },
        pageSection: {
          sectionName: sectionName ?? 'about',
        },
        ...eventingProductData,
      }}
    >
      {skill}
    </Link>
  );
};

export default SkillsTag;
